export default "__VITE_ASSET__DwbLkt9Z__"